<div class="header">
  <h2>Profilo <strong>Utente</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li><a routerLink="/user">Utenti</a></li>
      <li class="active">Profilo Utente</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-lg-12 portlets">
    <div class="panel widget-member clearfix" style="height: 300px;">
      <div class="col-md-3 col-md-offset-2 col-sm-3 col-sm-offset-2 hidden-xs">
        <img src="/assets/global/images/avatars/avatar1_big.png"
             alt="avatar 12"
             style="width: 50%;"
             class="pull-left img-responsive">
      </div>
      <div class="col-md-5 col-sm-5">
        <h3 class="m-t-0 member-name" style="font-size: 25px;"><strong>{{ user.username }}</strong></h3>
        <div class="row">
          <div class="col-xlg-12" style="font-size: 18px; margin-top: 20px;">
            <p><i class="fa fa-briefcase c-gray p-r-12"></i>&nbsp;<strong>Ruolo:</strong> {{ user.role.value }}</p>
            <p><i class="fa fa-user c-gray p-r-12"></i>&nbsp;<strong>Nome:</strong> {{ user.name + ' ' + user.surname}}</p>
            <p><i class="fa fa-envelope c-gray p-r-12"></i>&nbsp;<strong>E-Mail:</strong> {{ user.email }}</p>
            <p><i class="fa fa-phone c-gray p-r-12"></i>&nbsp;<strong>Numero di cellulare:</strong> {{ user.tel }}</p>
            <p><i class="fa fa-eye-slash c-gray p-r-12"></i>&nbsp;<strong>Attivo:</strong> {{ user.active ? 'Sì' : 'No' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
